/** @format */

import {ReactNode, useState} from 'react';

import {ClickAwayListener, Tooltip} from '@mui/material';

import {IconBox, StyledFilledIcon, StyledIcon} from './styles';

interface Props {
  testId?: string;
  title: ReactNode;
  placement?:
    | 'bottom-end'
    | 'bottom-start'
    | 'bottom'
    | 'left-end'
    | 'left-start'
    | 'left'
    | 'right-end'
    | 'right-start'
    | 'right'
    | 'top-end'
    | 'top-start'
    | 'top';
}

const HintIconTooltip = ({testId, title, placement}: Props) => {
  const [open, setOpen] = useState<boolean>(false);

  const handleHoverIn = () => {
    setOpen(true);
  };

  const handleHoverOut = () => {
    setOpen(false);
  };

  return (
    <ClickAwayListener onClickAway={handleHoverOut}>
      <Tooltip
        open={open}
        title={title}
        placement={placement}
        disableTouchListener
        disableFocusListener
        onMouseEnter={handleHoverIn}
        onMouseLeave={handleHoverOut}
        arrow
        slotProps={{
          tooltip: {
            sx: {
              bgcolor: 'transparent',
            },
          },
        }}
      >
        <IconBox {...(testId ? {['data-testid']: testId} : {})}>
          {open ? <StyledFilledIcon /> : <StyledIcon />}
        </IconBox>
      </Tooltip>
    </ClickAwayListener>
  );
};

export {HintIconTooltip};
